import styles from './TypingIndicator.module.css'

/**
 * Reserves the space below the composer. Nothing feeds typing presence, so it
 * stays empty.
 */
export function TypingIndicator() {
  return <div className={styles.root} />
}
